module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "Detail"
    }
  }, [_c('div', [_c('div', {
    staticClass: "title"
  }, [_c('p', [_vm._v("个人信息资料")]), _vm._v(" "), _c('span', [_vm._v("(" + _vm._s(_vm._f("dateMoment")(_vm.detail.updatedAt, "YYYY-MM-DD HH:mm")) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "phone"
  }, [_c('div', {
    staticClass: "tel"
  }, [_c('p', {
    staticClass: "tel_"
  }, [_vm._v("手机号")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.detail.mobile))])])]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "body_Detail"
  }, [_c('ul', [_c('li', {
    staticClass: "li"
  }, [_c('p', {
    staticClass: "tel_text"
  }, [_vm._v("姓   名")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.detail.name))])]), _vm._v(" "), _c('li', {
    staticClass: "li"
  }, [_c('p', {
    staticClass: "tel_text"
  }, [_vm._v("性   别")]), _vm._v(" "), _c('p', {
    staticClass: "text_sex"
  }, [_vm._v(_vm._s(_vm.inner))])]), _vm._v(" "), _c('li', {
    staticClass: "li"
  }, [_c('p', {
    staticClass: "tel_store"
  }, [_vm._v("门   店")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.detail.store))])]), _vm._v(" "), _c('li', {
    staticClass: "remark"
  }, [_c('p', {
    staticClass: "remark_text"
  }, [_vm._v("备   注")]), _vm._v(" "), _c('p', {
    staticClass: "remark_"
  }, [_vm._v(_vm._s(_vm.detail.remark))])])])]), _vm._v(" "), _c('div', {
    staticClass: "photo"
  }, [_c('p', [_vm._v("照   片")]), _vm._v(" "), _vm._l((_vm.detail.imgUrl), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "float"
    }, [_c('img', {
      attrs: {
        "src": item
      },
      on: {
        "click": function($event) {
          return _vm.getImg(_vm.detail.imgUrl, index)
        }
      }
    })])
  })], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b25d0d9","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/Detail.vue
// module id = 412
// module chunks = 1